<template>
  <div>
    <vs-row class="mb-10">
      <vs-button
        :to="{ name: 'new-services-category' }"
        class="rounded-full"
        color="primary"
        icon-pack="feather"
        icon="icon-plus-circle"
        type="filled"
        >Создать категорию</vs-button
      >
    </vs-row>

    <vx-card
      :title="`Категории Консьерж-сервис | Всего: ${totalCategories}`"
      class="p-6"
    >
      <vs-row class="mb-5">
        <div class="header-filter md:w-1/6 w-full mb-5 mr-5 cursor-pointer">
          <v-select
            @input="getCategories(currentPagingationPage, countElements)"
            :options="[5, 10, 20, 30, 50]"
            :clearable="false"
            placeholder="Количество категорий"
            v-model="countElements"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
      </vs-row>
      <vs-row class="-mx-4">
        <vs-col
          v-for="(item, index) in categories"
          :key="index"
          class="w-full px-4 sm:w-1/2 lg:w-1/5 mb-base"
        >
          <router-link
            :to="{ path: `/services/category/${item.id}` }"
            class="card-wrap"
          >
            <vs-card actionable class="cardx pb-1">
              <div slot="media">
                <img :src="item.image" />
              </div>
              <div>
                <h3 class="mb-3">{{ item.name }}</h3>
                <h6 class="text-primary mb-3">
                  Дата создания: {{ item.date_created }}
                </h6>
                <h6 class="text-primary mb-3">
                  Статус: {{ item.is_closed ? "Закрыто" : "Открыто" }}
                </h6>
              </div>
            </vs-card>
          </router-link>
        </vs-col>
      </vs-row>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>
  </div>
</template>

<script>
import { API_URL } from "@/.env";

export default {
  data: () => ({
    BASE_URL: API_URL,
    activeCreatePrompt: false,

    categories: [],

    countElements: 20,

    currentPagingationPage: 1,
    totalCategories: 0,
    totalPagePagination: 1,
  }),
  components: {},
  watch: {
    countElements: function () {
      this.currentPagingationPage = 1;
    },
    currentPagingationPage: function () {
      this.changePaginationPage(this.currentPagingationPage);
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
    getCategories(page, limit) {
      this.$vs.loading();

      let payload = {};

      if (page && limit) {
        payload.page = page ? page : 1;
        payload.limit = limit ? limit : 20;
      }

      this.$load(async () => {
        let res = (
          await this.$api.services.getCategories(payload ? payload : "")
        ).data;

        this.totalCategories = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalCategories / this.countElements
        );

        res.results.forEach((category) => {
          category.date_created = this.formatDate(category.date_created);
          category.image = this.BASE_URL + category.image;
        });

        this.categories = res.results;
        this.$vs.loading.close();
      });
    },
    changePaginationPage(page) {
      this.getCategories(page, this.countElements);
    },
  },
  created() {},
  mounted() {
    this.getCategories();
  },
};
</script>